var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPermitinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 25 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.552 5.964V3c0-1.283-1.066-2.333-2.37-2.333H3.224A2.341 2.341 0 00.866 3v2.964c0 .805.391 1.598 1.114 1.971A2.352 2.352 0 013.224 10c0 .887-.51 1.669-1.256 2.054-.711.385-1.114 1.178-1.114 1.983V17c0 1.284 1.067 2.334 2.37 2.334h18.958c1.304 0 2.37-1.05 2.37-2.334v-2.963c0-.805-.403-1.598-1.114-1.983A2.331 2.331 0 0122.182 10c0-.886.51-1.656 1.256-2.053.711-.385 1.114-1.178 1.114-1.983zM13.888 16.417h-2.37v-2.333h2.37v2.333zm0-5.25h-2.37V8.834h2.37v2.333zm0-5.25h-2.37V3.584h2.37v2.333z",
    fill: "inherit"
  })));
}

export default SvgPermitinline;